import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  z-index: 100;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: env(safe-area-inset-top);
`;

const NavContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  /* Mobile-first: compact padding */
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (min-width: 640px) {
    padding: 1rem 1.5rem;
  }

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

const Logo = styled(Link)`
  font-size: 0.9rem;
  font-weight: bold;
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  padding: 0.5rem 0;
  min-height: 44px;
  display: flex;
  align-items: center;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1rem;

  @media (min-width: 768px) {
    gap: 2rem;
  }
`;

const NavLink = styled(Link)<{ active: boolean }>`
  color: ${props => props.active ? '#fff' : 'rgba(255, 255, 255, 0.7)'};
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.5rem 0.75rem;
  min-height: 44px;
  display: flex;
  align-items: center;

  &:hover {
    color: #fff;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
    padding: 0.5rem 0;
  }
`;

const MainNavigation: React.FC = () => {
  const location = useLocation();
  
  // Hide navigation on detail pages (both projects and exhibitions)
  const shouldHideNav = 
    location.pathname.match(/^\/projects\/[^/]+$/) || // Project detail pages
    location.pathname.match(/^\/exhibitions\/[^/]+$/) || // Exhibition detail pages
    location.pathname.match(/^\/exhibitions\/the-smoke\/[^/]+$/) || // The Smoke artist pages
    location.pathname.match(/^\/exhibitions\/in-outscape\/[^/]+$/) || // In : Outscape artist pages
    location.pathname.match(/^\/exhibitions\/undo-redo\/[^/]+$/); // Undo Redo artist pages

  if (shouldHideNav) {
    return null;
  }

  return (
    <Nav>
      <NavContainer>
        <Logo to="/">Déjà Gallery</Logo>
        <NavLinks>
          <NavLink to="/" active={location.pathname === '/'}>
            Exhibitions
          </NavLink>
          <NavLink to="/projects" active={location.pathname === '/projects'}>
            Projects
          </NavLink>
        </NavLinks>
      </NavContainer>
    </Nav>
  );
};

export default MainNavigation; 